import * as SplashScreen from 'expo-splash-screen';

export class SplashScreenManager {
  private static isHidden = false;

  static async preventAutoHide() {
    try {
      await SplashScreen.preventAutoHideAsync();
      console.log('[SplashScreen] Auto-hide prevented');
    } catch (e) {
      console.warn('[SplashScreen] Error preventing auto-hide:', e);
    }
  }

  static async hide() {
    if (this.isHidden) {
      console.log('[SplashScreen] Already hidden');
      return;
    }

    try {
      await SplashScreen.hideAsync();
      this.isHidden = true;
      console.log('[SplashScreen] Hidden successfully');
    } catch (e) {
      console.warn('[SplashScreen] Error hiding:', e);
    }
  }

  static async hideAfterDelay(delay: number = 1000) {
    setTimeout(async () => {
      await this.hide();
    }, delay);
  }
}